"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToE164 = void 0;
var awesome_phonenumber_1 = require("awesome-phonenumber");
var compose_1 = __importDefault(require("lodash/fp/compose"));
var prop_1 = __importDefault(require("lodash/fp/prop"));
/**
* Normalize mobile phone number into E.164 format.
*
* @example
* ```typescript
* formatToE164('+1(201) 569-8900') // '+12015698900'
* formatToE164('(817) 569-8900') // undefined
* formatToE164('(817) 569-8900', { regionCode: 'US' }) // '+12015698900'
* ```
* */
var formatToE164 = function (phoneNumber, config) {
    if (config === void 0) { config = {}; }
    return (0, compose_1.default)(function (number) { return number !== null && number !== void 0 ? number : undefined; }, (0, prop_1.default)('number.e164'))((0, awesome_phonenumber_1.parsePhoneNumber)(phoneNumber, config));
};
exports.formatToE164 = formatToE164;
